require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./she-shines-with-win-pe.json") })
        }
      }, "path---she-shines-with-win-pe");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---she-shines-with-win-pe!./.cache/json/she-shines-with-win-pe.json
// module id = 1198
// module chunks = 231608221292675